import type React from 'react';

import { AutorenewIcon } from '@vlabs/icons';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import st from './SynchronizeStatus.module.sass';

export interface SynchronizeStatusProps {
  /** true — синхронизирован (зелёный), false — не синхронизирован (серый) */
  synchronized: boolean;
  className?: string;
  'data-testid'?: string;
}

function SynchronizeStatus({
  synchronized,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: SynchronizeStatusProps): React.JSX.Element {
  const { t } = useTranslation();
  const state = synchronized ? 'synced' : 'unsynced';

  return (
    <span
      className={cn(st.SynchronizeStatus, st[`SynchronizeStatus_${state}`], className)}
      data-testid={dataTestId}
      title={t(`entities:sources.sync.${state}`)}
    >
      <AutorenewIcon className={st.SynchronizeStatusIcon} />
    </span>
  );
}

export { SynchronizeStatus };
